import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

export interface TableBlock {
  content: string[][];
}

@Component({
  selector: 'sidkik-editor-js-table',
  templateUrl: './editor-js-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorJsTableComponent {
  @Input() content!: TableBlock;
}
